import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormInput from "../FormInput";
import { useParams } from "react-router-dom";
import useCaseDetailsContext from "../../hooks/useCaseDetailsContext";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from "sweetalert2";
import { getMasterAllCheckSubList, getMasterFieldOfficerList } from "../../redux/actions/MasterActions";
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { getCurrentDateMysql, getCurrentTimeMysql, getDateTimeMysqlGivenFormatYmd, getDisplayDateTimeFormat} from '../../util/generalUtills'
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddCaseGenerated = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const caseCtx = useCaseDetailsContext();
  const {
    pathname,
    actions,
    caseDetailsLists,
    loadingCaseDetails,
    errorsCaseDetails,
    changedCaseDetailsStatus,
    resetStatusType,
  } = caseCtx;
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const [checkedParentItems, setCheckedParentItems] = useState({});
  const [checkedSubItems, setCheckedSubItems] = useState({});
  const [assignedItems, setAssignedItems] = useState({}); // Track which items are assigned to which officers
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    masterReducer: {
      masterFoLists,
      masterAllCheckSubLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (show && auth?.token)
    {
      dispatch(getMasterFieldOfficerList(auth?.token, id));
      dispatch(getMasterAllCheckSubList(auth.token));
    }
  }, [show, auth?.token, dispatch]);


  const [validated, setValidated] = useState(false);
  

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);

    // 1) Naye (unassigned) items jo user ne check kiye hain
    const fromChecked = Object.entries(checkedSubItems)
      .filter(([key, value]) => value.checked && !assignedItems[key])
      .map(([key]) => key);

    // 2) Edit mode me, is allocation ke saare already assigned items bhi payload me bhejo
    const fromExistingAllocation = editId
      ? Object.entries(assignedItems)
          .filter(([, value]) => value?.allocationId === editId)
          .map(([key]) => key)
      : [];

    // Dono ko merge karke unique list banao
    const selectedSubChecklistIds = Array.from(new Set([...fromChecked, ...fromExistingAllocation]));

    // Check if any selected items are already assigned
    const alreadyAssignedItems = Object.entries(checkedSubItems)
      .filter(([key, value]) => value.checked && assignedItems[key])
      .map(([key]) => {
        const item = masterAllCheckSubLists
          ?.flatMap(list => list.checklist_subchecklist || [])
          .find(sub => sub.id === parseInt(key));
        return item?.name || key;
      });

    // if (alreadyAssignedItems.length > 0) {
    //   toast.error(`These items are already assigned: ${alreadyAssignedItems.join(', ')}`);
    //   return;
    // }

    // if (selectedSubChecklistIds.length === 0) {
    //   toast.warning("Please select at least one checklist item to assign.");
    //   return;
    // }

    // if (!formData?.fo_id) {
    //   toast.error("Please select an Investigator.");
    //   return;
    // }

    const updatedFormData = {
      ...formData,
      sub_checklist_id: selectedSubChecklistIds,
      case_id: "01"
    };

    if(id)
    {
      dispatch(actions.saveAssignFieldOfficer(auth?.token, updatedFormData, id));
    }
  };

  useEffect(() => {
    if(id)
    {
      dispatch(actions.fetchCaseDetailsById(auth?.token, id, pathname));
    }
  }, [auth, id, pathname, dispatch, actions]);

  
  useEffect(() => {
    if (show && editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) {
      const allocation = caseDetailsLists?.caseIdCaseFieldOfficerAllocation?.find(
        alloc => alloc?.id === editId
      );

      if (allocation) {
        // Pre-fill investigator
        setFormData({
          fo_id: allocation?.foIdCaseFieldOfficerAllocation?.id
        });

        // Pre-select already assigned sub-checklist items for this allocation
        const initialCheckedSubs = {};

        allocation?.fieldOfficerCaseCheckListDocument?.forEach(document => {
          const subChecklistId = document?.subCheckListCaseCheckListDocument?.id;
          if (subChecklistId) {
            initialCheckedSubs[subChecklistId] = { checked: true };
          }
        });

        if (Object.keys(initialCheckedSubs).length > 0) {
          setCheckedSubItems(prev => ({
            ...prev,
            ...initialCheckedSubs
          }));

          // Mark parent checklists as checked if they have any checked sub-item
          if (masterAllCheckSubLists && Array.isArray(masterAllCheckSubLists)) {
            const initialCheckedParents = {};

            masterAllCheckSubLists.forEach(parent => {
              const hasAnyCheckedSub = parent?.checklist_subchecklist?.some(
                sub => initialCheckedSubs[sub?.id]?.checked
              );

              if (hasAnyCheckedSub) {
                initialCheckedParents[parent.id] = { checked: true };
              }
            });

            setCheckedParentItems(prev => ({
              ...prev,
              ...initialCheckedParents
            }));
          }
        }
      }
    }
  }, [show, editId, caseDetailsLists, masterAllCheckSubLists]);

  // Load existing assignments from caseDetailsLists
  useEffect(() => {
    if (caseDetailsLists && caseDetailsLists?.caseIdCaseFieldOfficerAllocation && Array.isArray(caseDetailsLists.caseIdCaseFieldOfficerAllocation)) {
      const assignments = {};
      caseDetailsLists.caseIdCaseFieldOfficerAllocation.forEach(allocation => {
        const officerId = allocation?.foIdCaseFieldOfficerAllocation?.id;
        const officerName = allocation?.foIdCaseFieldOfficerAllocation?.name;

        if (officerId && officerName && allocation?.fieldOfficerCaseCheckListDocument) {
          // Extract all sub-checklist items assigned to this officer and allocation
          allocation.fieldOfficerCaseCheckListDocument.forEach(document => {
            const subChecklistId = document?.subCheckListCaseCheckListDocument?.id;
            if (subChecklistId) {
              assignments[subChecklistId] = {
                officerId: officerId,
                officerName: officerName,
                allocationId: allocation?.id
              };
            }
          });
        }
      });
      setAssignedItems(assignments);
    }
  }, [caseDetailsLists, masterFoLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const customCheckboxMargin = {
    marginBottom: '20px',
    fontSize: '12pt',
    color: 'blue',
  };

  
  useEffect(() => {
    if (!changedCaseDetailsStatus?.success) return;

    const selectedSubChecklistIds = Object.entries(checkedSubItems)
      .filter(([key, value]) => value.checked)
      .map(([key]) => key);

    const currentOfficer = masterFoLists?.find((fo) => fo.id === formData?.fo_id);
    if (currentOfficer && selectedSubChecklistIds.length > 0) {
      setAssignedItems((prevAssigned) => {
        const updated = { ...prevAssigned };
        selectedSubChecklistIds.forEach((itemId) => {
          updated[itemId] = {
            officerId: currentOfficer.id,
            officerName: currentOfficer.name,
          };
        });
        return updated;
      });
    }

    setCheckedSubItems({});
    setCheckedParentItems({});
    setFormData({});

    dispatch({ type: resetStatusType });

    swal.fire({
      title: "Well done!",
      text: changedCaseDetailsStatus?.message,
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
      didOpen: () => {
        document.querySelectorAll(".swal2-container").forEach((el) => {
          el.style.zIndex = "10050";
        });
      },
    }).then(() => {
      onHide();
    });
  }, [
    changedCaseDetailsStatus,
    dispatch,
    checkedSubItems,
    formData,
    masterFoLists,
    resetStatusType,
    onHide,
  ]);

  const checkParentItemHandler = (parentId, subItems = []) => {
    setCheckedParentItems(prevState => {
      const newParentChecked = !prevState[parentId]?.checked;
  
      setCheckedSubItems(prevSubState => {
        const updatedSubItems = { ...prevSubState };
  
        subItems.forEach(item => {
          // Only allow checking if item is not already assigned
          if (!assignedItems[item.id]) {
            updatedSubItems[item.id] = { checked: newParentChecked };
          }
        });
  
        return updatedSubItems;
      });
  
      return {
        ...prevState,
        [parentId]: { checked: newParentChecked }
      };
    });
  };
  
  
  const handleSubCheck = (itemId, parentId, subItems = []) => {
    setCheckedSubItems(prevState => {
      const updatedSubItems = {
        ...prevState,
        [itemId]: {
          checked: !prevState[itemId]?.checked
        }
      };
  
      // Ensure subItems is always an array
      const allChecked = subItems.length > 0 && subItems.every(sub => updatedSubItems[sub.id]?.checked);
  
      setCheckedParentItems(prevParentState => ({
        ...prevParentState,
        [parentId]: {
          checked: allChecked
        }
      }));
  
      return updatedSubItems;
    });
  };
  

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      setCheckedSubItems({});
      setCheckedParentItems({});
      setFormData({});
      setValidated(false);
    }
  }, [show]);

  // All unassigned sub-checklist ids (for Select All)
  const unassignedSubIds = masterAllCheckSubLists
    ?.flatMap((list) => list?.checklist_subchecklist || [])
    ?.filter((sub) => !assignedItems[sub?.id])
    ?.map((sub) => sub?.id) || [];

  const isAllChecklistSelected =
    unassignedSubIds.length > 0 &&
    unassignedSubIds.every((subId) => checkedSubItems[subId]?.checked);

  const handleSelectAllChecklist = (checked) => {
    if (checked) {
      const newCheckedSubs = { ...checkedSubItems };
      const newCheckedParents = { ...checkedParentItems };
      masterAllCheckSubLists?.forEach((parent) => {
        const subs = parent?.checklist_subchecklist || [];
        const hasUnassigned = subs.some((sub) => !assignedItems[sub?.id]);
        if (hasUnassigned) {
          newCheckedParents[parent?.id] = { checked: true };
          subs.forEach((sub) => {
            if (!assignedItems[sub?.id]) {
              newCheckedSubs[sub?.id] = { checked: true };
            }
          });
        }
      });
      setCheckedSubItems(newCheckedSubs);
      setCheckedParentItems(newCheckedParents);
    } else {
      setCheckedSubItems({});
      setCheckedParentItems({});
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) ? t("Update Case Allocation") : t("Add Case Allocation")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsCaseDetails?.data?.message && (
          <div className="alert alert-danger">
            {errorsCaseDetails?.data?.message}
          </div>
        )}
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                {errors?.data?.message && (
                  <div className="alert alert-danger">
                    {errors.data.message}
                  </div>
                )}
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Investigator Name")}</Form.Label>
                      <Select
                        options={masterFoLists?.map(user => ({
                          ...user,
                          customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Dist: ${user?.distance} km | Alloc: ${user?.allocationCount} | Att: ${user?.todayAttendance} | Last Location: ${getDisplayDateTimeFormat(user?.lastLocation)}`
                        }))}
                        values={masterFoLists?.filter(user => user?.id === formData?.fo_id)?.map(user => ({
                          ...user,
                          customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Dist: ${user?.distance} km | Alloc: ${user?.allocationCount} | Att: ${user?.todayAttendance} | Last Location: ${getDisplayDateTimeFormat(user?.lastLocation)}`
                        }))}
                        name="fo_id"
                        labelField="customLabel"
                        valueField="id"
                        searchBy="name"
                        searchable={true}
                        placeholder={t("Select Investigator")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          if (selectedData.length > 0) {
                            selectHandler2(selectedData[0]?.id, "fo_id");
                          }
                        }}
                        itemRenderer={({ item, itemIndex, props, state, methods }) => (
                          <div 
                            onClick={() => methods.addItem(item)}
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #eee',
                              backgroundColor: state.values.find(val => val.id === item.id) ? '#e3f2fd' : 'white'
                            }}
                          >
                            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                              {item.name} <span style={{ color: '#666', fontSize: '0.9em' }}>({item?.adminUserType?.name})</span>
                            </div>
                            <div style={{ fontSize: '0.85em', color: '#555', marginBottom: '3px' }}>
                              {item?.citiesAdminUsers?.city_name}, {item?.citiesAdminUsers?.cities_state?.state_name}
                            </div>
                            <div style={{ display: 'flex', gap: '15px', fontSize: '0.8em', marginTop: '5px' }}>
                              <span style={{ color: '#2196F3' }}>
                                <strong>Dist:</strong> {item?.distance} km
                              </span>
                              <span style={{ color: '#FF9800' }}>
                                <strong>Alloc:</strong> {item?.allocationCount}
                              </span>
                              <span style={{ 
                                color: item?.todayAttendance === 'Present' ? '#4CAF50' : item?.todayAttendance === 'Not Working' ? '#F44336' : '#666',
                                fontWeight: '500'
                              }}>
                                <strong>Att:</strong> {item?.todayAttendance}
                              </span>
                              <span style={{ color: '#666' }}>Last Location: {getDisplayDateTimeFormat(item?.lastLocation)}</span>
                            </div>
                          </div>
                        )}
                        // contentRenderer={({ props, state, methods }) => {
                        //   const selectedItem = state.values[0];
                        //   if (!selectedItem) {
                        //     return <div style={{ padding: '8px', color: '#999' }}>{props.placeholder}</div>;
                        //   }
                        //   return (
                        //     <div style={{ padding: '8px' }}>
                        //       <div style={{ fontWeight: 'bold' }}>
                        //         {selectedItem.name} <span style={{ color: '#666', fontSize: '0.9em' }}>({selectedItem?.adminUserType?.name})</span>
                        //       </div>
                        //       <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                        //         {selectedItem?.citiesAdminUsers?.city_name} | {selectedItem?.distance} km | Alloc: {selectedItem?.allocationCount} | Att: {selectedItem?.todayAttendance}
                        //       </div>
                        //     </div>
                        //   );
                        // }}
                        styles={customSelectStyles}
                      />

                      {errorsCaseDetails?.data?.fo_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.fo_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

              </Card.Body>
            </Card>

            {Array.isArray(masterAllCheckSubLists) && masterAllCheckSubLists.length > 0 && (
              <div className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  id="selectAllChecklist"
                  checked={isAllChecklistSelected}
                  onChange={() => handleSelectAllChecklist(!isAllChecklistSelected)}
                  style={{ fontWeight: '600' }}
                />
              </div>
            )}

            {masterAllCheckSubLists?.map((item) => {
              // Get assigned officers for this checklist
              const assignedOfficersMap = {};
              item?.checklist_subchecklist?.forEach(subItem => {
                if (assignedItems[subItem?.id]) {
                  const officerName = assignedItems[subItem?.id].officerName;
                  if (officerName) {
                    if (!assignedOfficersMap[officerName]) {
                      assignedOfficersMap[officerName] = [];
                    }
                    assignedOfficersMap[officerName].push(subItem?.name);
                  }
                }
              });

              // Create label with assigned officers info
              const assignedOfficersList = Object.keys(assignedOfficersMap);
              const assignedInfo = assignedOfficersList.length > 0 
                ? ` (Assigned to: ${assignedOfficersList.join(', ')})`
                : '';

              return (
                <Card key={item?.id} className="mb-3">
                  <Card.Body>
                    <Form.Check
                      type="checkbox"
                      label={`${item?.name} Check List :-${assignedInfo}`}
                      id={`checkbox${item?.id}`}
                      checked={
                        item?.checklist_subchecklist?.every(sub => assignedItems[sub?.id]) 
                          ? true 
                          : (checkedParentItems[item?.id]?.checked || false)
                      }
                      onChange={() => checkParentItemHandler(item?.id, item?.checklist_subchecklist)}
                      disabled={item?.checklist_subchecklist?.every(sub => assignedItems[sub?.id])}
                      style={item?.checklist_subchecklist?.every(sub => assignedItems[sub?.id]) ? {
                        cursor: 'not-allowed',
                        color: '#6c757d'
                      } : {}}
                    />

                    <Row className="mt-2">
                      {item?.checklist_subchecklist?.map((subItem) => {
                        const isAssigned = !!assignedItems[subItem?.id];
                        const isDisabled = isAssigned; // Pehle se assigned hoga to hamesha disabled

                        return (
                          <Col lg={3} key={subItem?.id}>
                            <div 
                              style={isDisabled ? { 
                                marginBottom: '8px'
                              } : {marginBottom: '8px'}}
                            >
                              <Form.Check
                                type="checkbox"
                                label={subItem?.name}
                                id={`subcheckbox${subItem?.id}`}
                                checked={
                                  isAssigned
                                    ? true // Jiska data pehle se aa raha hai, hamesha checked & read-only
                                    : (checkedSubItems[subItem?.id]?.checked || false)
                                }
                                onChange={() => handleSubCheck(subItem?.id, item?.id, item?.checklist_subchecklist)}
                                disabled={isDisabled}
                                style={isDisabled ? { 
                                  cursor: 'not-allowed',
                                  color: '#6c757d'
                                } : {}}
                              />
                            </div>
                          </Col>
                        );
                      })}

                    </Row>
                  </Card.Body>
                </Card>
              );
            })}
          </Col>
        </Row>

        <div className="d-flex justify-content-center">
          {loading ? 
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          :
            <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) ? t("Update") : t("Add")}
            </Button>
          }
        </div>
      </Modal.Body>
      {loadingCaseDetails && <Preloader />}
    </Modal>
  );
};

export default AddCaseGenerated;
